import styled from 'styled-components'

export const MedicalProfessionalReferralContainer = styled.div`
  width: 100%;
`

export const InputWrapper = styled.div`
  margin-top: 10px;
`

export const InputLegend = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    color: #898989;
  }
`